import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LocalStorageUtils } from "../helpers/LocalStorage";
import { RootState } from "./store";
import { BASE_URL } from "../constants/stringConstants";

export const commonApi = createApi({
  reducerPath: "commons",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set("Accept", "application/json");
      // headers.set("Content-Type", "multipart/form-data");
      const token = LocalStorageUtils.getItem("auth_token");
      if (token && endpoint !== "/auth/login" && endpoint !== "/auth/signup") {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    uploadImage: builder.mutation<any, any>({
      query: (data) => ({
        url: `attachments/upload`,
        method: "POST",
        body: data,
      }),
    }),

    getCompanyDetails: builder.mutation<any, any>({
      query: ({ param }) => ({
        url: `company/${param}`,
        method: "GET",
      }),
    }),

    getNotificationListing: builder.mutation<any, any>({
      query: ({ obj }) => ({
        url: `notifications?filter=${obj}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useUploadImageMutation,
  useGetCompanyDetailsMutation,
  useGetNotificationListingMutation,
} = commonApi;

// 'https://123.123.123.123/goods/121'
